import { SelectProps } from "antd/es";
import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import { CommonProps } from "../common/common-props";
import { SingleSelect } from "../single-select/single-select";

interface IMultiSelectProps extends SelectProps<any> {
  datatextfield?: string;
  datavaluefield?: any;
  onChange?: (value: any) => void;
  defaultText?: string;
  sortBy?: string;
  value?: string | any[];
  dropdownScrollItemLimit?: number;
}

interface IMultiSelectState {}

class MultiSelect extends PureComponent<IMultiSelectProps & CommonProps, IMultiSelectState> {
  constructor(props: IMultiSelectProps) {
    super(props);
  }

  private normalizeValue = (value: string | any[] | undefined): any[] | undefined => {
    if (!value) return undefined;

    if (typeof value === "string") {
      return value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    }

    return Array.isArray(value) ? value : [value];
  };

  getProps = () => {
    const props: any = _.clone(this.props);
    const style: any = _.clone(this.props.style);

    if (props.options && Array.isArray(props.options) && props.options.length > 0) {
      props.options = props.options.map((option: any) => ({
        ...option,
        originalKey: this.props.datavaluefield ? option[this.props.datavaluefield] : option?.key,
        compareKey: this.props.datavaluefield
          ? option[this.props.datavaluefield]?.toString()?.toLowerCase()
          : option?.key?.toString()?.toLowerCase()
      }));
    } else {
      props.options = [];
    }

    if (props.value) {
      const values = this.normalizeValue(props.value);
      props.value = values
        ?.map((v) => {
          if (v == null) return v;
          const vLower = v?.toString()?.toLowerCase();
          const matchingOption = props.options?.find((opt: any) => opt?.compareKey === vLower);
          return matchingOption?.originalKey ?? v;
        })
        .filter(Boolean);
    }

    props.mode = "multiple";
    style.display = "inline-block";
    props.listHeight = this.props.dropdownScrollItemLimit ? this.props.dropdownScrollItemLimit * 32 : undefined;
    props.style = style;

    if (!props.value) {
      props.value = undefined;
    }
    return props;
  };

  render(): ReactNode {
    return (
      <>
        <SingleSelect {...this.getProps()}></SingleSelect>
      </>
    );
  }
}

const multiSelect = MultiSelect;
export { multiSelect as MultiSelect };
